/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Toggle_PlaybackInputs */

const en_shortcut_keys_desc_toggle_playback = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_PlaybackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play or pause video playback`)
};

const fr_shortcut_keys_desc_toggle_playback = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_PlaybackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lire ou mettre en pause la lecture video`)
};

const de_shortcut_keys_desc_toggle_playback = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_PlaybackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videowiedergabe abspielen oder pausieren`)
};

const it_shortcut_keys_desc_toggle_playback = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_PlaybackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riproduci o metti in pausa la riproduzione video`)
};

const ru_shortcut_keys_desc_toggle_playback = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_PlaybackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Воспроизвести или приостановить воспроизведение видео`)
};

const es_shortcut_keys_desc_toggle_playback = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_PlaybackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reproducir o pausar la reproducción del vídeo`)
};

const zh_cn2_shortcut_keys_desc_toggle_playback = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_PlaybackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`播放或暂停视频播放`)
};

const ja_shortcut_keys_desc_toggle_playback = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_PlaybackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオの再生または一時停止`)
};

const hi_shortcut_keys_desc_toggle_playback = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_PlaybackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो प्लेबैक को चलाएं या रोकें`)
};

const pt_pt2_shortcut_keys_desc_toggle_playback = /** @type {(inputs: Shortcut_Keys_Desc_Toggle_PlaybackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reproduzir ou pausar a reprodução do vídeo`)
};

/**
* | output |
* | --- |
* | "Play or pause video playback" |
*
* @param {Shortcut_Keys_Desc_Toggle_PlaybackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_toggle_playback = /** @type {((inputs?: Shortcut_Keys_Desc_Toggle_PlaybackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Toggle_PlaybackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_toggle_playback(inputs)
	if (locale === "de") return de_shortcut_keys_desc_toggle_playback(inputs)
	if (locale === "it") return it_shortcut_keys_desc_toggle_playback(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_toggle_playback(inputs)
	if (locale === "es") return es_shortcut_keys_desc_toggle_playback(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_toggle_playback(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_toggle_playback(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_toggle_playback(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_toggle_playback(inputs)
	return en_shortcut_keys_desc_toggle_playback(inputs)
});